import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from '@amzn/awsui-components-console/spinner';
import Alert from '@amzn/awsui-components-console/alert';
import Box from '@amzn/awsui-components-console/box';
import Button from '@amzn/awsui-components-console/button';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import { consumeCognitoCallback, getExternalAuthConfig } from '../../shared/auth/cognitoAuth';

// Hosted UI redirect target for the Media Processing pages. Kept separate from /callback,
// which is the Federate implicit-flow callback used by the rest of the Portal.
const CognitoCallbackPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  // The authorization code is single-use; never exchange it twice.
  const consumed = useRef(false);

  useEffect(() => {
    if (consumed.current) {
      return;
    }
    consumed.current = true;

    const config = getExternalAuthConfig();
    if (!config) {
      setError('External sign-in is not enabled for this environment.');
      return;
    }
    consumeCognitoCallback(config)
      .then(({ returnPath }) => navigate(returnPath, { replace: true }))
      .catch((err) => {
        // Reject without persisting anything.
        console.error('Cognito callback rejected:', err);
        setError('Sign-in could not be completed.');
      });
  }, [navigate]);

  if (error) {
    return (
      <Box padding="xxl">
        <SpaceBetween size="m">
          <Alert type="error" header="Sign-in failed">
            {error}
          </Alert>
          <Button onClick={() => navigate('/', { replace: true })}>Try again</Button>
        </SpaceBetween>
      </Box>
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spinner size="large" />
    </div>
  );
};

export default CognitoCallbackPage;
